export const DISCOUNT_AMOUNT_UPDATED_MESSAGE =
  "exhibitor.cart.discount.amount_updated";
